import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  logo: {
    width: '48px',
    height: '40px',
    borderRadius: '8px',
    border: `1px solid ${theme.palette.nubeWhite}`,
  },
}));

export default useStyles;
